<template>
  <div>
    <!-- 侧边功能按钮主体 start -->
    <div :class="isPc?'leftNav':'leftNavPc'">
      <div
        class="navItem"
        @click="gopage(item.id,item)"
        v-for="(item,index) in navList"
        :key="index"
      >
        <img class="navImg" :src="item.src" alt />
        <label class="navSpan">{{item.name}}</label>
      </div>
    </div>
    <!-- 侧边功能按钮主体 end -->

    <!-- 卖旧车弹窗Pc start -->

    <el-dialog
      class="oldCar"
      v-if="isPc"
      title="高价卖旧车"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="dialogDetail w10 h10" v-if="detailStatus">
        <div class="el-icon-close detailClose" @click="closeDetails"></div>
        <div class="dialogDetailBox w10 h10">
          <div class="title">{{detailDialog.title}}</div>
          <div class="content">
            <p>{{detailDialog.titleText}}</p>
            <p v-for="(item,index) in detailDialog.details" :key="index">{{item}}</p>
          </div>
        </div>
      </div>
      <el-dialog class="oldCar" title="高价卖旧车" :visible.sync="innerVisible" append-to-body>
        <div>
          <div class="carModelDiv">
            <div class="carInputDiv">
              <div class="inputDiv dialogInput">
                <el-select
                  v-model="oldCarList.carSeries"
                  @change="changeSeries"
                  placeholder="请选择车系"
                >
                  <el-option
                    v-for="item in carSeriesList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="carInputDiv">
              <div class="inputDiv dialogInput">
                <el-select v-model="oldCarList.carModel" placeholder="请选择车型" @change="changeModel">
                  <el-option
                    v-for="item in carModelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="carInputDiv">
              <div class="inputDiv dialogInput">
                <el-select v-model="oldCarList.carSet" placeholder="请选择配置" @change="changeSet">
                  <el-option
                    v-for="item in carSetList"
                    :key="item.id"
                    :label="item.inPh"
                    :value="item.inPh"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="carModelDiv">
            <div class="carBigImg w10">
              <img class="w10 h10" :src="oldCarList.url" alt />
            </div>
            <!-- <div>{{oldCarList.carSeries + oldCarList.carModel + oldCarList.carSet}}</div> -->
            <div v-if="oldCarList.price">指导价:{{oldCarList.price}}万元</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="innerVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <div v-if="dialogStep === 1">
        <div class="w10 carCard el-icon-arrow-right" @click="changeCar()">
          <div :class="['url',oldCarList.url?'':'urlNone']">
            <img class="w10 h10" v-if="oldCarList.url" :src="oldCarList.url" alt />
          </div>
          <div class="carContent h10">
            <p v-if="oldCarList.carSeries" class="carType">{{oldCarList.carSeries}}</p>
            <p
              v-if="oldCarList.carModel"
              class="carMessage"
            >{{oldCarList.carModel}}{{oldCarList.carSet}}</p>
          </div>
        </div>
        <div class="carInputDiv">
          <div class="carInputImg">
            <img class="w10 h10" src="../assets/image/milestone.png" alt />
          </div>
          <div class="inputDiv dialogInput">
            <el-select v-model="oldCarList.mileage" placeholder="请选择已行驶里程数">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>

        <div class="carInputDiv">
          <div class="carInputImg">
            <img class="h10 w10" src="../assets/image/date.png" alt />
          </div>
          <div class="inputDiv dialogInput">
            <el-date-picker v-model="oldCarList.licensingTime" type="date" placeholder="请选择上牌时间"></el-date-picker>
          </div>
        </div>
        <div class="addressDiv">
          <div class="addressImg">
            <img class="h10 w10" src="../assets/image/address.png" alt />
          </div>
          <div class="inputDiv addressInput">
            <el-cascader
              v-model="city"
              :options="cityList"
              :props="props"
              :show-all-levels="false"
              @change="handleChange"
            ></el-cascader>
          </div>
        </div>
      </div>
      <div v-if="dialogStep ===2">
        <div class="backStep" @click="backStep">
          <img :src="backImg" alt />
          返回上一步
        </div>
        <div class="carInputDiv carInputDiv2">
          <div class="carInputImg">
            <img class="w10 h10" src="../assets/image/name.png" alt />
          </div>
          <div class="inputDiv dialogInput">
            <el-input v-model="oldCarList.name" placeholder="请输入姓名"></el-input>
          </div>
        </div>
        <div class="carInputDiv">
          <div class="carInputImg">
            <img class="w10 h10" src="../assets/image/phone.png" alt />
          </div>
          <div class="inputDiv dialogInput">
            <el-input v-model="oldCarList.phone" placeholder="请输入手机号"></el-input>
            <div class="inputMessage">已开启号码保护</div>
          </div>
        </div>
      </div>
      <span v-if="dialogStep === 1" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogStep=2">1/2 &nbsp;下一步</el-button>
      </span>
      <span class="soldCar dialog-footer" v-if="dialogStep === 2" slot="footer">
        <el-button type="primary" @click="dialogVisible = false;saveSoldText()">高价卖车</el-button>
        <div class="subMessage">
          点击“高价卖车”即同意
          <span class="subRunTo" @click="showDetails">《个人信息保护声明》</span>
        </div>
      </span>
    </el-dialog>
    <!-- 卖旧车弹窗PC end -->
    <!-- 卖旧车弹窗移动端 start -->

    <div v-if="!isPc&&dialogVisible" class="w10 h10 mobileSold">
      <div class="dialogDetail w10 h10" v-if="detailStatus">
        <div class="el-icon-close detailClose" @click="closeDetails"></div>
        <div class="dialogDetailBox w10 h10">
          <div class="title">{{detailDialog.title}}</div>
          <div class="content">
            <p>{{detailDialog.titleText}}</p>
            <p v-for="(item,index) in detailDialog.details" :key="index">{{item}}</p>
          </div>
        </div>
      </div>
      <div class="closeBtn" @click="handleClose">返回</div>
      <div class="remainInfo">
        <p class="titles">
          您的详细信息
          <label class="red">*</label>
        </p>
        <ul>
          <li class="pr oh fl w10">
            <div class="el-input">
              <input
                type="text"
                v-model="oldCarList.name"
                autocomplete="off"
                placeholder="姓名"
                class="el-input__inner"
              />
            </div>
          </li>

          <li class="pr oh fl w10">
            <div class="w10 el-input">
              <input
                type="text"
                autocomplete="off"
                v-model="oldCarList.phone"
                maxlength="11"
                placeholder="电话"
                class="el-input__inner"
              />
            </div>
          </li>
          <li class="pr oh fl w10">
            <div class="w10 el-input">
              <el-cascader
                class="w10"
                v-model="city"
                :options="cityList"
                :props="props"
                placeholder="选择您的城市"
                :show-all-levels="false"
                @change="handleChange"
              ></el-cascader>
            </div>
          </li>

          <li class="cb"></li>
        </ul>

        <p class="titles">
          您的车况
          <label class="red">*</label>
        </p>
        <ul>
          <li class="pr oh fl w10">
            <div class="el-input">
              <el-select v-model="oldCarList.carSeries" placeholder="请选择车系" @change="changeSeries">
                <el-option
                  v-for="item in carSeriesList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </li>
          <li class="pr oh fl w10">
            <div class="el-input">
              <el-select v-model="oldCarList.carModel" placeholder="请选择车型" @change="changeModel">
                <el-option
                  v-for="item in carModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </li>
          <li class="pr oh fl w10">
            <div class="el-input">
              <el-select v-model="oldCarList.carSet" placeholder="请选择车的配置" @change="changeSet">
                <el-option
                  v-for="item in carSetList"
                  :key="item.id"
                  :label="item.inPh"
                  :value="item.inPh"
                ></el-option>
              </el-select>
            </div>
          </li>
          <li class="pr oh fl w10">
            <div class="el-input">
              <el-select v-model="oldCarList.mileage" placeholder="请选择行驶里程数">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </li>
          <li class="pr oh fl w10">
            <div class="el-input">
              <el-date-picker v-model="oldCarList.licensingTime" type="date" placeholder="请选择上牌时间"></el-date-picker>
            </div>
          </li>

          <li class="cb"></li>
          <div class="subMessage">
            点击“高价卖车”即同意
            <span class="subRunTo" @click="showDetails">《个人信息保护声明》</span>
          </div>
          <div class="soldCarBtn" @click="saveSoldText">高价卖车</div>
        </ul>
      </div>
    </div>
    <!-- 卖旧车弹窗移动端 start -->
  </div>
</template>

<script>
import global from "../assets/js/global";

export default {
  name: "leftNav",

  data() {
    return {
      dialogVisible: false, //卖旧车弹窗开启状态
      innerVisible: false, //卖旧车二级弹窗开启状态
      detailStatus: false, //卖旧车个人信息声明开启状态
      navList: [
        //侧边功能按钮
        {
          id: "1",
          name: "询价",
          src: require("../assets/image/nav1.png"),
          url: "https://www.naveco.com.cn/reservation",
          mobileUrl: "https://vr.naveco.com.cn/#/online"
        },
        {
          id: "2",
          name: "测贷款",
          src: require("../assets/image/nav2.png"),
          url: "https://www.naveco.com.cn/calculator",
          mobileUrl: "https://vr.naveco.com.cn/#/calculator"
        },
        {
          id: "3",
          name: "免费试驾",
          src: require("../assets/image/nav3.png"),
          url: "https://www.naveco.com.cn/testdrive",
          mobileUrl: "https://vr.naveco.com.cn/#/reservePilot"
        },
        // {
        //   id: "4",
        //   name: "卖旧车",
        //   src: require("../assets/image/nav4.png"),
        //   url: ""
        // },
        {
          id: "5",
          name: "经销商查询",
          src: require("../assets/image/nav5.png"),
          url: "https://www.naveco.com.cn/dealer",
          mobileUrl: "https://vr.naveco.com.cn/#/merchant"
        },
        {
          id: "6",
          name: "服务商查询",
          src: require("../assets/image/nav6.png"),
          url: "https://www.naveco.com.cn/support",
          mobileUrl: "https://vr.naveco.com.cn/#/facilitator"
        }
      ],
      city: [], //选中城市
      oldCarList: {
        //卖旧车默认信息
        url: require("../assets/image/car.png"),
        carSeries: "依维柯·欧胜",
        series: "",
        carModel: "2021款 2.3T 高顶多功能车侧拉门",
        carSet: "F1A",
        name: "",
        phone: "",
        config: "",
        city: "",
        price:'',
        province: "",
        mileage: "",
        licensingTime: ""
      },
      carSeriesList: [], //车系 array
      carModelList: [], //车型 array
      carSetList: [], //配置 array
      options: [], //行驶里程数 array

      props: {
        //配置tree树
        expandTrigger: "hover",
        value: "id",
        label: "name",
        children: "data"
      },
      cityList: [], //城市 array
      dialogStep: 1, //卖旧车步骤
      phone: "", //联系电话
      name: "", //姓名
      backImg: require("../assets/image/back.png"), //返回图片地址
      detailDialog: global.dialogDetail //静态资源里的个人信息声明
    };
  },
  mounted() {
    this.getCityList();
    this.getSeriesList();
    this.getmileageList();
  },
  methods: {
    //获取里程
    getmileageList() {
      this.$fetch("/app/autoShow/selectAllDicDetail", { code: "mileage" }).then(
        res => {
          this.options = res.data;
        }
      );
    },
    //获取城市list
    getCityList() {
      this.$fetch("app/autoShow/selectAllProvinceAndCitys", {}).then(res => {
        this.cityList = res.data;
      });
    },
    //获取车系list
    getSeriesList() {
      this.$fetch("/app/autoShow/findAllSeries ", { deleteFlag: "0" }).then(
        res => {
          this.carSeriesList = res.data;
          this.onClose();
        }
      );
    },

    // 侧边栏点击
    gopage(n, item) {
      // console.log(n, url);
      if (n != 4) {
        let url = this.isPc ? item.url : item.mobileUrl;
        window.open(url, "_blank");
        return;
      }
      this.onClose();
      this.dialogVisible = true;
    },
    //车系变化
    changeSeries(name) {
      this.carSeriesList.map(v => {
        this.oldCarList.carModel = "";
        this.oldCarList.model = "";
        this.oldCarList.carSet = "";
        this.oldCarList.config = "";
        if (v.name == name) {
          this.oldCarList.series = v.id;
          this.carModelList = v.carModel;
        }
      });
    },
    //车型变化
    changeModel(name) {
      this.oldCarList.carSet = "";
      this.oldCarList.config = "";
      this.carModelList.map(v => {
        if (v.name == name) {
          // console.log(name, v);
          this.oldCarList.model = v.id;
          this.carSetList = v.data;
          this.oldCarList.url = this.carSetList[0].url;

        }
      });
    },
    //配置变化
    changeSet(name) {
      this.carSetList.map(v => {
        if (v.inPh == name) {
          this.oldCarList.url = v.url;
          this.oldCarList.price = v.pice;
          this.oldCarList.config = v.id;
          // console.log(this.oldCarList);
        }
      });
    },
    // 更换车型
    changeCar() {
      this.innerVisible = true;
    },
    // 弹框关闭
    handleClose() {
      this.dialogVisible = false;
      this.dialogStep = 1;
      this.onClose();
    },
    //城市改变方法
    handleChange(value) {
      this.oldCarList.city = value[1];
      this.oldCarList.province = value[0];
    },

    // 弹框初始化
    onClose() {
      this.changeSeries(this.carSeriesList[0].name)
      this.changeModel(this.carSeriesList[0].carModel[0].name)
      this.oldCarList = {
        url: this.carSeriesList[0].carModel[0].data[0].url,
        carSeries: this.carSeriesList[0].name,
        series: this.carSeriesList[0].id,
        carModel: this.carSeriesList[0].carModel[0].name,
        model:this.carSeriesList[0].carModel[0].id ,
        carSet: this.carSeriesList[0].carModel[0].data[0].inPh,
        config: this.carSeriesList[0].carModel[0].data[0].config,
        price:this.carSeriesList[0].carModel[0].data[0].pice,
        city: "",
        province: "",
        mileage: "",
        name: "",
        phone: "",
        licensingTime: ""
      };
      console.log(this.oldCarList);
    },
    //backStep 返回上一步
    backStep() {
      this.dialogStep = 1;
    },
    //保存信息
    saveSoldText() {
      this.dialogStep = 1;
      // console.log(this.oldCarList);
      this.$fetch("/app/tUserdCar/save", this.oldCarList).then(res => {
        this.dialogVisible = false;
      });
      setTimeout(() => {
        this.onClose();
      }, 1000);
    },
    //打开弹窗
    showDetails() {
      this.detailStatus = true;
    },
    //关闭个人信息
    closeDetails() {
      this.detailStatus = false;
    }
  },
  computed: {
    isPc() {
      // true PC
      // false 大屏
      return this.$store.getters.isPC;
    }
  }
};
</script>

<style scoped>
@import url("../assets/css/nav.css");
</style>



// WEBPACK FOOTER //
// src/components/leftNav.vue